<script>
import { mapState } from 'vuex';
import Footer from '@/components/Patients/blocks/Footer/Footer';
import Quote from '@/components/Patients/blocks/Quote/Quote';
import Quiz from '@/components/Patients/blocks/Quiz/Quiz';
import progressBar from '@/components/Patients/blocks/ProgressBar/ProgressBar';
import GraphAnimation from '@/components/Patients/blocks/GraphAnimation/GraphAnimation';
import Accordion from '@/components/Patients/blocks/Accordion/Accordion';
import Video from '@/components/Patients/blocks/Video/Video';
import SectionWrapper from '@/components/Patients/patients/section-wrapper';
import Tabs from '@/components/Patients/blocks/Tabs/Tabs';
import FooterButtons from '@/components/Patients/blocks/FooterButtons/FooterButtons';
import patientHead from '@/components/Patients/blocks/patientHead/patientHead';
import ScrollGraph from '@/components/Patients/blocks/ScrollGraph/ScrollGraph';
import ScrollMagic from 'scrollmagic';
import { SweetModal } from 'sweet-modal-vue';

export default {
  data() {
    return {
      ScrollPosition: 0
    }
  },
  extends: Video,
  components: {
    Footer,
    'progress-bar': progressBar,
    'graph-animation': GraphAnimation,
    'quote': Quote,
    'quiz': Quiz,
    'accordion': Accordion,
    'section-wrapper': SectionWrapper,
    'patient-video': Video,
    'patient-tabs': Tabs,
    'footer-buttons': FooterButtons,
    'section-head': patientHead,
    'scroll-graph': ScrollGraph,
    'sweet-modal': SweetModal
  },
  computed: {
    ...mapState(['userAgent', 'animationsData', 'controllerExist', 'urls', 'currentSection', 'scrollPositions', 'isiState']),
    isIE() {
      return this.userAgent.browser.name === 'ie';
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$parent.$parent.$refs['modal-video'].close();
    next();
  },
  methods: {
    toggleModal(target, time, el) {
      let targetVideo = this.$parent.$parent.$refs[target];
      if (time > 0 && el === 'susanPick') {
        this.$store.commit('SET_VIDEO_PROGRESS', time);
      }
      targetVideo.open();
    },
    modalClose() {},
    toggleVideo() {
      // console.log('play video!');
      this.$store.commit('TOGGLE_VIDEO', true);
    },
    // [REVIEW]
    // Move Scroll Event Listener here to create/destroy liestener for each page separately.
    patientsScroll(patient) {
      window.scrollTo(0, this.scrollPositions[patient]);
    },
    updatePatientsScroll(e) {
      if (this.$route.meta.id === 0) return true;
      this.ScrollPosition = window.pageYOffset || window.scrollY || document.body.scrollTop + (document.getElementById('app') && document.getElementById('app').scrollTop || 0);
      if (this.$route.meta.id === 1) {
        this.$store.commit('SET_PATIENTS_SCROLL_SUSAN', this.ScrollPosition);
      }
      if (this.$route.meta.id === 2) {
        this.$store.commit('SET_PATIENTS_SCROLL_JOSEPH', this.ScrollPosition);
      }
      if (this.$route.meta.id === 3) {
        this.$store.commit('SET_PATIENTS_SCROLL_GABRIELLE', this.ScrollPosition);
      }
    },
  },
  mounted() {
    if (document.querySelector('.site__wrapper')) {
      document.querySelector('.site__wrapper').classList.remove('height-auto');
      document.querySelector('.site__wrapper').style.overflow = 'auto';
    }
    this.patientsScroll(this.$route.name.toLowerCase());
    window.addEventListener('scroll', this.updatePatientsScroll);
    if (this.$route.hash === '#video') {
      this.toggleModal('modal-video');
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.updatePatientsScroll);
  }
};
</script>

<style lang="scss" src="./patient_base.scss"></style>


